import { render, staticRenderFns } from "./CourseTree.vue?vue&type=template&id=341d868a&scoped=true&"
import script from "./CourseTree.vue?vue&type=script&lang=js&"
export * from "./CourseTree.vue?vue&type=script&lang=js&"
import style0 from "./CourseTree.vue?vue&type=style&index=0&id=341d868a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d868a",
  null
  
)

export default component.exports